// src/redux/thunks/campaignThunk.js
import axiosInstance from "../../utils/axiosInterceptor";
import { reducersActions } from "./new-actions";

const {
    FETCH_CAMPAIGN_REQUEST,
    FETCH_CAMPAIGN_SUCCESS,
    FETCH_CAMPAIGN_FAILURE,
} = reducersActions;

export const fetchCampaignById = (campaignId) => async (dispatch) => {
  dispatch({ type: FETCH_CAMPAIGN_REQUEST });
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_BASE_URL_VMS}/api/v3/campaigns/getByCampaignId?campaign_id=${campaignId}`
    );
    dispatch({
      type: FETCH_CAMPAIGN_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_CAMPAIGN_FAILURE,
      payload: error.message,
    });
  }
};
